const common = {
  message: {
    failureMessageUpload: 'Something went wrong, please try again'
  }
};

export default common;
